import { render } from "./MessageIn.vue?vue&type=template&id=b3235e54"
import script from "./MessageIn.vue?vue&type=script&lang=js"
export * from "./MessageIn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__